import { buildSentryConfig } from "./common.mjs";
export function buildSentryClientConfig(dsn, themeName) {
  return buildSentryConfig(dsn, themeName);
}